export const sidebarWidth = 240

export const appBarHeight = 75
